import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '@mui/material';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import HourglassFullIcon from '@mui/icons-material/HourglassFull';
import RunningStatusIcon from './RunningStatusIcon';

TableStatusIcons.propTypes = {
  status: PropTypes.string,
  statusDetails: PropTypes.string,
};

export function TableStatusIcons({ status, statusDetails }) {
  if (!status) return null;

  return (
    <Tooltip title={[status, statusDetails].filter(Boolean).join(': ')}>
      {buildStatusIcon()}
    </Tooltip>
  );

  function buildStatusIcon() {
    if (/RUNNING/.test(status)) {
      return <RunningStatusIcon />;
    }

    if (/QUEUED/.test(status)) {
      return (
        <HourglassFullIcon
          sx={{ fontSize: 24, fillOpacity: 0.54 }}
          color="black"
        />
      );
    }

    if (/COMPLETE/.test(status)) {
      return (
        <CheckCircleIcon
          data-testid="completedIcon"
          sx={{ fontSize: 24 }}
          color="primary"
        />
      );
    }

    return (
      <CancelIcon
        data-testid="cancelIcon"
        sx={{ fontSize: 24 }}
        color="error"
      />
    );
  }
}
